<template>
  <div id="hres8ax-deduction-tab2" class="panel box-collapse border-color-skin">
   <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#deduction-tab2">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>เงินบริจาค
      </h3>
    </div>
    <div id="deduction-tab2" class="panel-collapse collapse tab-detailDeduction">
      <div class="panel-body">
         <hrms-table :columns="detailDeductionTable2" 
                     :data="detailDeduction"
                     :searchDisp="false"
                     :editInlineEventBool="true" 
                     :saveInlineBtnDisp="false"
                     :rowDisableCondition="rowDisableCondition" />  

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hres8ax-deduction-tab2',
  props: [
    'labels',
    'detailDeduction',
    'detailDeductionTable2'
  ],
  methods: {
    rowDisableCondition (dataRow) {
      return dataRow.amtdisable === 'N'
    }
  }
}
</script>


// WEBPACK FOOTER //
// deduction_2.vue?f3ec8c0a